
const Icon = (props) => {
  const {
    name,
    className
  } = props;
  return <i className={`iconfont icon-${name} ${className ? className : ''}`}></i>
}

export default Icon;